export default __webpack_public_path__ + "images/logo-hispatec-track-white.svg";